import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
import config from './config'

Vue.use(Router)
const router = new Router({
  scrollBehavior() {
    //   console.log(to)
    return { x: 0, y: 0 }
    //   return savedPosition
  },
  routes: [
    {
      path: '/help',
      redirect: '/home'
    },
    {
      path: '/',
      component: () => import('./views/Home'),
      redirect: '/home',
      meta: {
        authentication: true
      },
      children: [
        {
          path: 'home',
          name: 'Home',
          component: () => import('./views/Home'),
          meta: {
            title: 'Puls - Help Center'
          }
        }
      ]
    },
    {
      path: '/section/:section',
      name: 'Section',
      component: () => import('./views/Section'),
      meta: {
        title: 'Puls - Section'
      }
    },
    {
      path: '/section/:section/articles/:article',
      name: 'Article',
      component: () => import('./views/Article'),
      meta: {
        title: 'Puls - Article'
      }
    },
    {
      path: '/section/:section/articles/:article/edit',
      name: 'EditArticle',
      component: () => import('./views/EditArticle.vue'),
      meta: {
        title: 'Edit Article'
      }
    },
    {
      path: '*',
      component: () => import('./views/NotFound'),
      meta: {
        authentication: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Puls'
  next()
})

Vue.use(VueAnalytics, {
  id: config.googleAnalyticsId,
  router,
  debug: {
    enabled: false
  },
  autoTracking: {
    transformQueryString: false,
    exception: true
  }
})

export default router
